import { EduCapabilities, EduMode, EduStaffProfile } from './types';

export const EDU_MODES: EduMode[] = ['disabled', 'pilot', 'enabled'];
export const EDU_STAFF_PROFILES: EduStaffProfile[] = ['none', 'admin', 'secretaria', 'professor'];
const flags = ['canStudy', 'canManageCatalog', 'canMapModules', 'canReviewParticipations', 'canViewHistory', 'canManageAccess'] as const;

export function emptyEduCapabilities(): EduCapabilities {
    return { mode: 'disabled', staffProfile: 'none', accessVersion: '', canStudy: false,
        canManageCatalog: false, canMapModules: false, canReviewParticipations: false,
        canViewHistory: false, canManageAccess: false };
}

// Only the authenticated DTO may grant presentation capabilities; malformed data stays closed.
export function normalizeEduCapabilities(value: unknown): EduCapabilities {
    if (!value || typeof value !== 'object' || Array.isArray(value)) return emptyEduCapabilities();
    const input = value as Record<string, unknown>;
    if (!EDU_MODES.includes(input.mode as EduMode) || !EDU_STAFF_PROFILES.includes(input.staffProfile as EduStaffProfile)
        || typeof input.accessVersion !== 'string' || !input.accessVersion.trim()
        || flags.some(flag => typeof input[flag] !== 'boolean')) return emptyEduCapabilities();
    const result: EduCapabilities = { mode: input.mode as EduMode, staffProfile: input.staffProfile as EduStaffProfile,
        accessVersion: input.accessVersion, canStudy: input.canStudy === true, canManageCatalog: input.canManageCatalog === true,
        canMapModules: input.canMapModules === true, canReviewParticipations: input.canReviewParticipations === true,
        canViewHistory: input.canViewHistory === true, canManageAccess: input.canManageAccess === true };
    return result.mode === 'disabled' ? { ...emptyEduCapabilities(), accessVersion: result.accessVersion,
        canManageAccess: result.canManageAccess } : result;
}

export function requireEduRevision(revision: number): number {
    if (!Number.isSafeInteger(revision) || revision < 0) throw new Error('Atualize os dados de acesso antes de salvar.');
    return revision;
}
